import { Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { Tree } from 'src/targeting/tree';

export class Segment implements ICondition {
  segmentId?: number | null;

  constructor({ segmentId }: ConditionDataType) {
    this.segmentId = segmentId;
  }

  public evaluate(
    evaluationData: EvaluationDataType,
  ): Result<boolean, KameleoonError> {
    const { segments, trees } = evaluationData;

    if (!this.segmentId) {
      return Ok(false);
    }

    const segment = segments?.get(this.segmentId.toString());

    if (!segment) {
      return Ok(false);
    }

    const tree = trees?.get(this.segmentId.toString());

    if (tree) {
      return tree.evaluate(evaluationData);
    }

    return new Tree(segment).evaluate(evaluationData);
  }
}
